var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _image, _path27, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path28, _path29, _rect11, _rect12, _rect13, _rect14, _rect15, _circle, _path30, _path31, _rect16, _rect17, _rect18, _path32, _rect19, _rect20, _circle2, _rect21, _rect22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginAdm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 572.86 487.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#ebf6fc;}.cls-1{stroke:#f8fbff;}.cls-1,.cls-10,.cls-12,.cls-13,.cls-14,.cls-19,.cls-24,.cls-25{stroke-miterlimit:10;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#dda35e;}.cls-6{fill:#9cc8ff;}.cls-7{fill:#d1d4d4;}.cls-8{fill:#b3b3b3;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:#4296cf;stroke:#4296cf;}.cls-11{fill:#00479b;}.cls-12,.cls-13,.cls-15{fill:#ffe28e;}.cls-12{stroke:#ffeab9;}.cls-13{stroke:#ffe28e;}.cls-14{fill:#abd5ef;stroke:#abd5ef;}.cls-16{fill:#004969;}.cls-17{fill:url(#radial-gradient);}.cls-18{fill:url(#linear-gradient-4);}.cls-19,.cls-21{fill:#006aea;}.cls-19{stroke:#006aea;}.cls-20{fill:url(#linear-gradient-5);}.cls-22{fill:#fff;}.cls-23{fill:url(#linear-gradient-6);}.cls-24{fill:none;stroke:#9cc8ff;stroke-width:4px;}.cls-25{fill:url(#linear-gradient-7);stroke:url(#linear-gradient-8);}.cls-26{fill:url(#linear-gradient-9);}.cls-27{fill:url(#linear-gradient-10);}.cls-28{fill:url(#linear-gradient-11);}.cls-29{fill:url(#linear-gradient-12);}.cls-30{fill:url(#linear-gradient-13);}.cls-31{fill:url(#linear-gradient-14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 704.27,
    y1: 292.46,
    x2: 776.98,
    y2: 292.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#282a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#252425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 668.94,
    y1: 311.4,
    x2: 812.31,
    y2: 311.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#414041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#333132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 718.68,
    y1: 351.39,
    x2: 781.74,
    y2: 351.39,
    gradientTransform: "translate(-19.46 45.06) rotate(-3.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#afd7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c5e2f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d6ebf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e2f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e9f5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#e9f5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e2f3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d7eef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c6e8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0dff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95d5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76c9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73c8ec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 772.57,
    cy: 219.95,
    fx: 784.7645331156049,
    fy: 232.2770178230256,
    r: 17.34,
    gradientTransform: "translate(113.26 112.66) scale(0.82 0.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e3af7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e2ac77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#dea563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#dda35e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c59254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b0834b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 720.12,
    y1: 239.58,
    x2: 775.68,
    y2: 239.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4c4d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3e3d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#333132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2c2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 901.29,
    y1: 330.69,
    x2: 1090.68,
    y2: 330.69,
    gradientTransform: "matrix(1, 0, -0.03, 0.78, 13.68, 57.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#dfe6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 843.4,
    y1: 250.37,
    x2: 866.65,
    y2: 250.37,
    gradientTransform: "translate(1713.65 497.6) rotate(-179.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 932.86,
    y1: 225.61,
    x2: 1069.62,
    y2: 225.61,
    gradientTransform: "translate(-5.39 25.43) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9e3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bedcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#abd1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 932.36,
    y1: 225.61,
    x2: 1070.12,
    y2: 225.61,
    gradientTransform: "translate(-5.39 25.43) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e8f4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e0effc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d1e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bcdbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 942.93,
    y1: 218.96,
    x2: 998,
    y2: 218.96,
    gradientTransform: "translate(-5.23 24.65) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e8f3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e1e8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#d4d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1030.37,
    y1: 207.76,
    x2: 1049.86,
    y2: 207.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dbdddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1003.21,
    y1: 195.88,
    x2: 1029.11,
    y2: 195.88,
    gradientTransform: "matrix(1, 0.03, 0.03, -1, -5.22, 365.97)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1001.45,
    y1: 240.39,
    x2: 1050.46,
    y2: 240.39,
    gradientTransform: "matrix(1, 0.03, 0.03, -1, -6.34, 454.72)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 978.54,
    y1: 305.29,
    x2: 1031.27,
    y2: 305.29,
    gradientTransform: "translate(-14.15 51.19) rotate(-2.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1030.39,
    y1: 188.35,
    x2: 1049.95,
    y2: 188.35,
    gradientTransform: "translate(-4.44 26.4) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852.35,199.48c56.57,34.36,102.92,94.7,83.81,118.36-15.22,18.83-57.55-3.34-127.47,11.84-52.81,11.47-64.15,31.83-85.56,37.6a75.85,75.85,0,0,1-17.68,1.32c-38-2-123.33-107.57-91.44-167.3,21.86-41,88.22-40.47,120.26-40.24C748.29,161.16,797.55,166.21,852.35,199.48Z",
    transform: "translate(-519.05 -160.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.47,232.16H728.64c-7.95,0-14.4,10.43-14.4,23.29-4.15,3.43-8.84,8.46-8.41,14.16.45,6.12,6.39,7.33,7.13,13.67,1,8.74-9.49,13-7.75,19.94,1.59,6.36,11.18,6.39,11.67,11.63.56,6-11.65,8.11-12.56,15.95-.81,7,7.62,15.67,14.46,15.22,6.38-.43,7-8.5,13.62-9.82,11.24-2.23,23.62,18,25.72,16.47.58-.43.26-2.47-3-8.91,6.35-6.34,13.15-15.47,14-27,1-12.83-6.08-19.14-5.52-32.37.31-7.41,3-17.35,13.28-28.94C777.09,254,778.22,245.93,762.47,232.16Z",
    transform: "translate(-519.05 -160.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M762.3,232.63c-10.53-.14-21.15-.18-31.75-.17h-2a10.2,10.2,0,0,0-1.91.25,10.32,10.32,0,0,0-3.52,1.57,17.44,17.44,0,0,0-5,6,32.38,32.38,0,0,0-3.45,15.21v.21l-.17.14c-2.72,2.32-5.38,4.93-6.79,8.17a9.44,9.44,0,0,0-.83,4.94,6.85,6.85,0,0,0,.65,2.27,7.57,7.57,0,0,0,1.35,1.85c1.11,1.14,2.61,2.08,4.2,3.57a13.9,13.9,0,0,1,3.89,6.17,16.7,16.7,0,0,1,.34,8,51.17,51.17,0,0,1-2.06,6.92c-.16.49-.33,1-.45,1.42a10.11,10.11,0,0,0-.33,1.28,4.6,4.6,0,0,0-.12,1.1,1.5,1.5,0,0,0,.11.81l.14.29a.56.56,0,0,0,.27.1.5.5,0,0,0,.27,0,2.12,2.12,0,0,0,.36-.21,2.66,2.66,0,0,0,.65-.8l.12-.26.15-.27a2.93,2.93,0,0,0,.19-.57,5,5,0,0,0,.21-1.22,4.76,4.76,0,0,0,0-1.31c0-.38-.16-.81-.09-1.07a2,2,0,0,0,0-.43l.13-.31c.1-.41.61-.55,1.22-.67l.61,0a3.83,3.83,0,0,1,.67,0,12.29,12.29,0,0,1,1.78.28c.35.08.68.15,1,.25l1.33.48.66.25.84.42c.56.29,1.09.56,1.68.92a21.77,21.77,0,0,1,8.09,9.63,23.53,23.53,0,0,1,1.8,11.6,26.41,26.41,0,0,1-.7,3.9c-.16.61-.34,1.22-.54,1.82s-.39,1.08-.61,1.61l-.33.8-.33.71c-.22.45-.45.91-.69,1.36s-.44.79-.67,1.19L732,331.9l-.63,1-.62.89c-1.59,2.22-2.8,3.68-3.72,4.91a21.82,21.82,0,0,0-1.94,2.93c-.76,1.49-.55,2.49,1.09,1.84a8.9,8.9,0,0,0,3.19-2.77,17.9,17.9,0,0,0,3-6.14,16.87,16.87,0,0,0,.69-3.3,5.87,5.87,0,0,1,.1-.73c0-.23.06-.46.07-.69a12.72,12.72,0,0,0,0-1.38,34,34,0,0,0-.2-4.09,25.57,25.57,0,0,0-1-4.79,9.11,9.11,0,0,0-2.3-3.84,8,8,0,0,0-1.25-1.08,12.81,12.81,0,0,0-1.75-1.13l-.54-.28-.62-.3c-.42-.19-.84-.36-1.28-.52l-.74-.25c-.27-.1-.56-.18-.84-.26a17.37,17.37,0,0,0-1.74-.37l-1-.17c-.37,0-.74-.1-1.11-.13a20.6,20.6,0,0,0-2.22-.09c-.78,0-1.77,0-2.65.12l-1.35.18-1.39.25a28.21,28.21,0,0,0-5.69,1.81c-.44.19-.88.4-1.31.62l-1.22.65a20.62,20.62,0,0,0-2.06,1.26c-.74.53-1.11.75-1.6,1.12l-.68.53a6.71,6.71,0,0,1-.57.46,12.39,12.39,0,0,1-1.24,1l-.15.08s-.13.11-.09,0l.1-.3a1,1,0,0,1,.08-.19l.24-.38.47-.77.84-1.2.43-.59.61-.78,1.3-1.58c.19-.23.54-.6.83-.9l.91-.95.94-.93.48-.47.59-.52c.8-.71,1.62-1.39,2.45-2.05s1.83-1.36,2.83-2,2-1.29,3.09-1.89a48.22,48.22,0,0,1,6.95-3.1A49.58,49.58,0,0,1,727,298.7a48.43,48.43,0,0,1,13.49-.46,52.17,52.17,0,0,1,10.75,2.38,54.67,54.67,0,0,1,7.9,3.32,64.46,64.46,0,0,1,10.52,6.77,78.15,78.15,0,0,1,6.84,6.06c1.86,1.87,3.46,3.63,4.61,5a13.28,13.28,0,0,1,1.16,1.47c.05.11,0,.13-.31-.13l-.86-.68-.86-.65-.65-.47-.83-.58-1-.67c-.51-.32-1-.63-1.55-.92l-1-.55c-.4-.21-.81-.41-1.23-.61l-.62-.29-.8-.34c-.65-.28-1.32-.54-2-.78l-1-.34-1.23-.38c-1.07-.3-2.16-.56-3.25-.77-.55-.11-1.1-.2-1.65-.28s-1.56-.21-2.32-.27a37.34,37.34,0,0,0-5.07-.08c-.72,0-1.93.12-3.09.28s-2.29.35-3.43.61-2.25.57-3.35.93-2.36.83-3.52,1.35a37.87,37.87,0,0,0-12.28,8.67,38.35,38.35,0,0,0-4.12,5.22,37.31,37.31,0,0,0-2.67,4.79c-.38.83-.73,1.67-1,2.51-.26.69-.4,1.11-.59,1.68-.35,1.08-.66,2.18-.91,3.29-.12.55-.23,1.11-.33,1.67l-.22,1.4c-.09.65-.17,1.3-.22,2s-.09,1.31-.11,2v1.63c0,.75,0,1.51.12,2.26l.11,1.12.08.67c.07.43.13.87.21,1.3l.22,1.07c.11.51.24,1,.38,1.51.1.33.18.59.28.89l.15.42.1.25.2.48c.11.24.17.34.26.51a.53.53,0,0,0,.16.17c.15,0,.16-.26.08-.72,0-.21-.11-.5-.16-.75l-.21-.89-8.28-35,15.06-8.15c1.81-1,3.41-1.74,4.63-2.26a9,9,0,0,1,3.09-.78c.89,0,1.8-.14,2.71-.25.49-.07.89-.45,1.18-1.36a14.72,14.72,0,0,0,.11-4.7c-.08-1-.24-2.41-.36-3.7-.14-1.48-.28-2.89-.39-4.55s-.16-3.33-.17-5,.07-3.47.27-5.21a54.14,54.14,0,0,1,5.42-18.93,53.1,53.1,0,0,1,4.73-7.7,49.75,49.75,0,0,1,5.49-6.37,64.05,64.05,0,0,1,12.1-9.43l-2.94,6.26c.09.09.18.27.29.4s.22.22.32.22a.5.5,0,0,0,.32,0A.68.68,0,0,0,766,254a3.53,3.53,0,0,0,.83-1.76,16,16,0,0,0-.17-5.79,48.77,48.77,0,0,0-1.79-6.78c-.4-1.15-.87-2.36-1.25-3.5A26.18,26.18,0,0,0,762.3,232.63Zm.35-.94a25.67,25.67,0,0,1,3.93,1.23c1.31.49,2.5,1,3.78,1.48a45.3,45.3,0,0,1,7.32,4,29.85,29.85,0,0,1,6.92,6.42,22.18,22.18,0,0,1,2.92,5c.22.47.39,1,.58,1.57a15.42,15.42,0,0,1,.48,1.76,17.76,17.76,0,0,1,.33,2c.07.72.1,1.49.1,2.16l-2.93,6.26a46.26,46.26,0,0,0-2.24,10c-.1.77-.08,1.52-.12,2.25s0,1.43.07,2.1a14.82,14.82,0,0,0,.66,3.65,13.33,13.33,0,0,0,1.25,2.87,7.54,7.54,0,0,0,.8,1.17l.43.5c.15.16.32.3.45.44s.63.55.91.8a11.81,11.81,0,0,1,1,.93c.32.3.76.82,1.16,1.29a24.64,24.64,0,0,1,1.45,2.05,43.35,43.35,0,0,1,3.63,6.86A52.89,52.89,0,0,1,798.86,309c.43,1.94.69,4,.93,5.95s.34,4,.32,5.95a62.94,62.94,0,0,1-1,11.74,75,75,0,0,1-7.14,21,84.85,84.85,0,0,1-5.1,8.73,92.13,92.13,0,0,1-5.61,7.62l6.78-43.14,1,1.55c.35.57.68,1.09,1,1.71.7,1.18,1.46,2.54,2.3,4.26.23.48.44.92.67,1.44s.47,1.13.73,1.8l.42,1.13.2.57.24.75.46,1.55c.2.72.37,1.45.54,2.17l.12.6.15.81c.1.55.19,1.09.26,1.64l.11.83.13,1.3c.07.86.11,1.73.13,2.6v.73l0,1.07q0,1.06-.12,2.13c-.06.72-.14,1.43-.23,2.13,0,.26-.13.89-.24,1.49s-.22,1.16-.35,1.75c-.27,1.16-.58,2.32-.95,3.45-.2.6-.34,1.05-.61,1.76-.33.87-.7,1.73-1.1,2.59a39.59,39.59,0,0,1-2.74,4.94,39.1,39.1,0,0,1-9.84,10.26,39.55,39.55,0,0,1-6.94,4c-1.19.53-2.55,1-3.6,1.38s-2.27.68-3.43.95-2.34.47-3.52.63-2.43.26-3.17.29a38.2,38.2,0,0,1-5.24-.09c-.79-.06-1.91-.2-2.41-.27l-1.73-.3c-1.15-.22-2.29-.5-3.41-.82-.64-.18-1-.28-1.32-.4l-1.09-.37c-.72-.26-1.44-.54-2.15-.84l-.87-.38-.7-.32c-.47-.22-.93-.45-1.39-.69l-.68-.36-.49-.27c-.62-.35-1.24-.72-1.84-1.09s-.89-.57-1.33-.87l-1.11-.77-.92-.68c-.51-.38-1-.74-1.39-1.08l-1-.86-.84-.72c-1-.88-1.69-1.5-2.28-2l-2.64-2.46-3-2.83a15.44,15.44,0,0,1-1.28-1.25c-.07-.15.21,0,1.51.6A25.1,25.1,0,0,0,725,373a28.45,28.45,0,0,0,5.45,1.05,29.85,29.85,0,0,0,8-.43,27.56,27.56,0,0,0,8.92-3.29,24.79,24.79,0,0,0,6-4.66l.42-.48.34-.43c.13-.18.26-.37.38-.57a1.6,1.6,0,0,0,.15-.26v-.07l0-.15-.39.3-.19.15-.35.34-1.87,1.91c-.65.66-1.95,1.94-3.09,3l-1.07.93-1.19,1c-.83.66-1.52,1.22-2.65,2s-2.11,1.39-3.19,2c-.5.31-1.19.67-1.81,1s-1.27.63-1.92.93a41.58,41.58,0,0,1-8.24,2.77c-.72.17-1.39.29-2.06.39s-1.35.2-2,.28c-1.33.15-2.77.28-4,.29s-2.4,0-3.59-.11l-1.79-.14-.89-.1-.78-.12q-1.56-.26-3.09-.6c-.51-.11-1-.23-1.52-.37l-.75-.2-.65-.21c-.87-.28-1.73-.59-2.59-.91l-1.27-.5-.63-.26-.55-.25c-1.45-.69-2.93-1.45-4.26-2.23s-2.46-1.56-3.63-2.41a47.13,47.13,0,0,1-10.56-10.94,49.19,49.19,0,0,1-6.8-14c-.2-.72-.4-1.44-.58-2.16l-.25-1.08c-.09-.36-.17-.73-.24-1.15a48.17,48.17,0,0,1-.68-4.92c-.06-.92-.1-1.83-.12-2.74v-1.37c0-.45,0-.89.06-1.41a41.42,41.42,0,0,1,.83-6A34.18,34.18,0,0,1,681,315.42a32.6,32.6,0,0,1,6.35-7.21,26.76,26.76,0,0,1,9.4-5.22,6,6,0,0,1,2.46-.33c.52.12.71.42.39,1.33l-.05.16-.1.22c-.07.15-.13.3-.19.45s-.18.38-.26.57-.14.38-.26.64-.23.52-.33.79l-.33.9a9,9,0,0,0-.3,1,12,12,0,0,0-.3,1.18,16.33,16.33,0,0,0-.28,5.24,14.19,14.19,0,0,0,1.42,4.89,10.08,10.08,0,0,0,4.92,5.27,2.6,2.6,0,0,0,.59.08h.29a.94.94,0,0,0,.09-.12l.18-.26a4.14,4.14,0,0,0-.13-.43,3.89,3.89,0,0,0-.61-1.06,6.35,6.35,0,0,0-.53-.64l-.58-.69c-1-1.05-2-2.12-3.34-3.66-.33-.39-.63-.76-1-1.16s-.69-.91-1-1.38a24,24,0,0,1-1.87-3.15,22.6,22.6,0,0,1-1.38-3.68,21,21,0,0,1-.59-3.83c0-.64,0-1.29,0-1.92l0-.94c0-.32.1-.63.15-.94a16.05,16.05,0,0,1,1-3.51c.21-.53.44-1,.68-1.54s.5-.85.76-1.26.53-.82.79-1.15l.8-.91a13.77,13.77,0,0,1,1.53-1.53,15.79,15.79,0,0,1,1.43-1.14c.48-.37.88-.64,1.3-.92s.81-.53,1.19-.76a38.73,38.73,0,0,0,3.61-2.4,5.43,5.43,0,0,0,2-2.68,5.52,5.52,0,0,0-.28-3.79c-.59-1.44-1.76-3-2.71-4.9a12.17,12.17,0,0,1-1.06-3,9.44,9.44,0,0,1-.18-1.58l0-.77.05-.77a13.46,13.46,0,0,1,1.84-5.54,31.21,31.21,0,0,1,7.4-8.27l-.17.35a33.36,33.36,0,0,1,3.76-15.55,18.12,18.12,0,0,1,5.26-6.09,10.86,10.86,0,0,1,3.72-1.67,10.65,10.65,0,0,1,2-.27h2C741.23,231.87,751.9,231.83,762.65,231.69Z",
    transform: "translate(-519.05 -160.52)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M794.8,389.92l9.78-.61c-.15-2.28-.34-6-.39-10.59-.08-6.44.2-7.6,0-12.22-.08-1.56-.1-1.27-1.3-12.05-.75-6.77-.89-8.18-1.31-11.42-.47-3.6-.92-6.57-1.24-8.61l-19.91,3.41,1.18,7c1.34,8.06,1.43,9,1.95,11.54A95.64,95.64,0,0,0,786.69,368c1.89,5.45,2.89,6.56,5.11,12.58C793.28,384.55,794.24,387.86,794.8,389.92Z",
    transform: "translate(-519.05 -160.52)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M672.6,373.15l-7.78-6.93c1.51-1.72,3.93-4.52,6.78-8.14,4-5.06,4.46-6.16,7.48-9.67,1-1.18.86-.94,8.43-8.7,4.76-4.87,5.73-5.9,8.06-8.19,2.59-2.55,4.77-4.61,6.28-6l14.53,15.83-5.22,4.75c-6,5.5-6.69,6.2-8.67,7.86a87.91,87.91,0,0,1-9.73,7.12c-4.9,3.08-6.41,3.31-11.93,6.61C677.15,369.89,674.32,371.88,672.6,373.15Z",
    transform: "translate(-519.05 -160.52)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "187.44 185.25 176.5 170.84 207.22 147.05 218.16 161.46 187.44 185.25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M706.43,346.26c-3.77-4.81-7.56-9.7-11.27-14.6h0l.1-.68a30.79,30.79,0,0,1,1.52-6,40.37,40.37,0,0,1,2.22-5.07,42.18,42.18,0,0,1,5.79-8.38,43.74,43.74,0,0,1,3.45-3.49c.6-.54,1.21-1.08,1.84-1.58a12.08,12.08,0,0,1,2-1.43,9.18,9.18,0,0,1,5.47-.86,21.66,21.66,0,0,1,8.46,3l.7.09,10.94,14.41-.09.7.79,1.53.39.78.19.38.15.33c.39.88.8,1.8,1.15,2.65l.82,2.31c.13.38.28.79.39,1.14l.27,1a20.48,20.48,0,0,1,.75,6.64,8.69,8.69,0,0,1-.49,2.31,5.5,5.5,0,0,1-.92,1.7,4.9,4.9,0,0,1-1.3,1.12c-.46.32-.93.63-1.4.94a42.48,42.48,0,0,1-11.95,5.34,27.23,27.23,0,0,1-11.52.79,14.55,14.55,0,0,1-2.5-.65l-1.17-.43c-.38-.18-.75-.38-1.11-.57a8.17,8.17,0,0,1-1-.65,7.62,7.62,0,0,1-.95-.77,6.55,6.55,0,0,1-.87-.94A5.41,5.41,0,0,1,706.43,346.26Zm.13-1,1.15-2.57,1-2.43,1-2.25.88-2.15.82-2.05.75-1.92,1.33-3.62c1.64-4.57,2.77-8.21,3.84-11.11a20.8,20.8,0,0,1,3.42-6.54c.16-.2.34-.38.51-.56a1,1,0,0,1,.63-.37,1.88,1.88,0,0,1,1,.22,8.86,8.86,0,0,1,1.44.82c1.16.82,2.59,1.95,4.58,3.67l.76.65.86.77,1.79,1.57,2.1,1.9,2.49,2.28-.1.7-10.93-14.4.7.09a21.86,21.86,0,0,1,.78,8.94,9.12,9.12,0,0,1-2.21,5.08,12.62,12.62,0,0,1-1.87,1.55c-.65.48-1.32.94-2,1.39a45.3,45.3,0,0,1-4.23,2.46,42.33,42.33,0,0,1-9.57,3.51,40.17,40.17,0,0,1-5.46.87,30.92,30.92,0,0,1-6.16,0l.09-.7C699.53,335.76,703,340.48,706.56,345.27Z",
    transform: "translate(-519.05 -160.52)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "266.29 189.73 284.21 184.51 272.92 147.84 255.01 153.06 266.29 189.73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M785.58,349.81c5.87-1.8,11.68-3.56,17.54-5.26l-.34.63A38.56,38.56,0,0,1,788,329.64a43.22,43.22,0,0,1-2.85-6.65,8.49,8.49,0,0,1,.5-7.68,21.94,21.94,0,0,1,5.81-6.81l.61.34-17.91,5.22.34-.63c3.34-.45,7.31-.95,10.66-1.28,2.61-.27,4.44-.37,5.85-.38a4.53,4.53,0,0,1,2.59.54c.38.35.31.91.4,1.39a20.45,20.45,0,0,1-1,7.24c-1.11,4.06-3.52,11.59-4.79,16.83-1,3.83-1.91,8.17-2.7,12Zm-.48.88c-7,2.83-14.15-2.38-18.77-7.8a41.54,41.54,0,0,1-6.61-11.09,12.23,12.23,0,0,1-1-3.19,7.29,7.29,0,0,1,1.17-4.05c2.33-3.95,7.82-7.78,12.16-10l1.54-.8.34-.63,17.91-5.22.62.33c5.9.72,10.2,2.06,12.58,6.17a40.64,40.64,0,0,1,.91,24.81,31.92,31.92,0,0,1-2.52,6.31c-6.09,1.78-12.24,3.51-18.32,5.19Z",
    transform: "translate(-519.05 -160.52)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M754.55,393.69l-23.69,1.55,15.57,40.56,12.05-1.3Z",
    transform: "translate(-519.05 -160.52)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M754.28,394c-7.83.58-15.59,1.14-23.39,1.64l.37-.58,43.18,30L743.22,406l12.1-.87L729,437.34c12.32-10,21.48-26.6,25.24-43.32Zm.55-.65c13.28,10.62,23.36,22,33.09,38.3l15.59,26.24c-8.94,1.29-45.72,6.54-53.87,7.72l-36.95,5.29,5.74-24.37,12-51.16.14-.56c8.07-.53,16.18-1,24.23-1.46Z",
    transform: "translate(-519.05 -160.52)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M828.82,593.69l-23.71,7.21-54-190.63,23.72-7.21Q788.2,458,805,516.15,816.59,556,828.82,593.69Z",
    transform: "translate(-519.05 -160.52)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M829.17,593.87l-24,7.25-.23.07c-2.23-8-4.61-16-6.92-24-4.49-15.92-9.82-31.57-15.88-47-8.89-22.36-19.11-47-25.54-70a72.77,72.77,0,0,1-2.69-12.1c-1.5-12.44.4-25.54-3.16-37.72l-.1-.37.36-.1c7-2,16.89-4.86,23.79-6.95l.12,0,0,.11q2.89,12,6.14,24c1.18,4,1.74,8.08,4.16,11.71,2.39,3.82,6.46,7.18,9.93,10.19,5.7,4.74,9.73,9.38,11.07,16.19l1.59,5.95c8.79,34,16.18,68.43,20,103.45.59,6.35,1.34,13,1.35,19.35Zm-.69-.36c-1-1.79-2.08-2.84-3.11-4.4-1.28-2-2.51-4.08-3.72-6.13C802.82,550.4,789.38,515,779,479l-1.67-6c-2.86-8-.22-15.16,2.73-23.25a37.42,37.42,0,0,0,2.44-10.24c.37-4.36-1.13-8.24-2-12.29q-2.85-12.06-5.79-24.08l.14.08c-3.94,1.23-7.9,2.42-11.83,3.69l-11.8,3.78.26-.48c2.33,8.09,6.61,15.43,11,22.62a78.34,78.34,0,0,1,10.11,22.87c9.07,31.26,12.64,65.6,19.9,97.33,3.72,16.1,8.36,31.95,12.79,47.85l-.29-.15,23.44-7.17Z",
    transform: "translate(-519.05 -160.52)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M768,394.43l-35.15,3.08a234.36,234.36,0,0,1-8.56-24.68c-3.54-12.4-5.9-20.67-6.18-31.37a85,85,0,0,1,5.64-32.37c5.36-2.22,8.8-1.69,10.91-.86,4.88,1.93,5,6.4,10.57,8.52.54.2,6.25,2.29,9.77-.4,2.91-2.22,1.21-5.35,4.17-8s8.49-2.8,12.25-.37a10.15,10.15,0,0,1,3.15,3.26c6.9,15,7,26.26,5.77,33.71-1.26,8-4,12.12-7.62,25.46A178.61,178.61,0,0,0,768,394.43Z",
    transform: "translate(-519.05 -160.52)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M749.45,334.77",
    transform: "translate(-519.05 -160.52)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "169.52 443.62 191.07 448.59 232.51 254.7 210.96 249.72 169.52 443.62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M688.85,604l21.35,4.83-.41.25c.72-8.29,1.66-16.54,2.71-24.76s2.21-16.43,3.45-24.61q3.74-24.54,8.35-48.9t9.9-48.57a237.77,237.77,0,0,1,6.92-23.87c1.35-3.93,2.87-7.83,4.51-11.71a108.33,108.33,0,0,1,5.61-11.47l.25.4-21.55-5,.4-.26a54.79,54.79,0,0,1,4.41,13.28A64,64,0,0,1,736,435.83a66.93,66.93,0,0,1-.93,11.7c-.64,3.85-1.63,7.67-2.47,11.5-3.55,15.31-7.51,30.58-11.94,46.11s-9.29,31.32-14.57,47.66c-2.68,8.19-5.36,16.47-8.24,25S692.09,594.93,688.85,604Zm-.56.36c.22-7.14.77-14.65,1.35-22.3s1.34-15.52,2.12-23.49c1.62-16,3.67-32.51,6.15-49.29s5.42-33.82,8.78-50.83c.88-4.25,1.63-8.51,2.71-12.74a85.74,85.74,0,0,1,4.25-12.54,73.66,73.66,0,0,1,6.45-12,51.07,51.07,0,0,1,9.59-11l.33-.27.07,0,21.55,5,.21.05,0,.35a107.44,107.44,0,0,1,.42,12.76c-.08,4.21-.29,8.39-.67,12.53a235,235,0,0,1-3.44,24.61c-3.32,16.18-7,32.3-10.82,48.37s-8,32.1-12.37,48.05q-3.32,12-6.91,23.87c-2.4,7.93-4.91,15.84-7.65,23.7l-.12.33-.28-.07Z",
    transform: "translate(-519.05 -160.52)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M808.93,294.68",
    transform: "translate(-519.05 -160.52)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M824.27,279.54",
    transform: "translate(-519.05 -160.52)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M720.41,372",
    transform: "translate(-519.05 -160.52)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M855.13,360.74l0,.06c1.31,1.79.38,4.36-2,5.66-2,1.07-4.3,2.33-6.86,3.77-6.79,3.82-7.87,4.67-12.83,7.3-1.69.9-1.4.71-13.3,6.5-7.49,3.63-9,4.41-12.65,6.11-1.9.9-3.65,1.71-5.2,2.43-2.45,1.13-5.21.47-6.15-1.45l-3.07-6.29c-.93-1.89.29-4.3,2.72-5.38l3.5-1.57c9.13-4.07,10.18-4.59,13.09-5.82,6.58-2.76,11.87-4.54,13.79-5.18,6.67-2.21,8.34-2.32,15.77-4.68,3-1,5.65-1.86,7.81-2.64A4.69,4.69,0,0,1,855.13,360.74Z",
    transform: "translate(-519.05 -160.52)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M787.19,323.56",
    transform: "translate(-519.05 -160.52)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M774,311.85",
    transform: "translate(-519.05 -160.52)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M801.55,293.88",
    transform: "translate(-519.05 -160.52)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M851.23,627.11c5.27,6.85,7.9,10.27,6.51,12.52-3.3,5.35-25.72,3.12-39.26-7.91-3.34-2.72-9.19-7.5-7.81-12.92,1.46-5.7,10.38-9.95,17.5-9.86C837.32,609.05,842.93,616.34,851.23,627.11Z",
    transform: "translate(-519.05 -160.52)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M761.67,309c-1.14,5.49-4,7.31-4.64,7.71-5,3-13.91-.11-19.82-9.31a26.87,26.87,0,0,0,1.88-3.37,23.86,23.86,0,0,0,2.11-6.29,43.44,43.44,0,0,0,.48-5.84c.07-1.68.09-3.37.1-4.4,0-1.28,0-2.35,0-3.13h14.46c-.06.77-.13,1.85-.19,3.13-.07,1.56-.14,3-.1,4.61a31.61,31.61,0,0,0,.58,5.42c0,.09,0,.19.07.3a28.27,28.27,0,0,0,2.65,6.85C759.84,305.82,760.64,307.29,761.67,309Z",
    transform: "translate(-519.05 -160.52)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M772.94,258.87c-.2,6.45-.38,11-2.58,16.09a29.94,29.94,0,0,1-6.76,9.43c-4.16,4.3-7,7.27-10.91,7.26s-6.42-2.8-10.9-7.53c-2.87-3-6-6.34-8.07-12.12-1.63-4.53-1.79-8.33-2-13.13-.35-7.93-.55-12.68,1.34-17.29,3.59-8.74,12.73-12.11,19.27-12.13s15.7,3.4,19.34,12.13C773.34,245.6,773.21,250,772.94,258.87Z",
    transform: "translate(-519.05 -160.52)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M766.64,226.73A45.3,45.3,0,0,0,749,223.64a49,49,0,0,0-16.9,3.68c-2.87,1.06-4.09,2.37-6.49,4.81-1.5,1.52-4,2.83-4.12,3.42l-1.21,5.31c-.66,2.86,1.3,5.55,4.38,6.24h.07a16.22,16.22,0,0,1,4.95,2.37,58.85,58.85,0,0,0,8.14,3.72,30.26,30.26,0,0,0,12.4,2.32,23.31,23.31,0,0,0,10.3-2.47c3.51-1.83,4-3.44,8.2-6.22a35.69,35.69,0,0,1,3.8-2.21,5.36,5.36,0,0,0,3-6.1q-.62-3.26-1.24-6.49Z",
    transform: "translate(-519.05 -160.52)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M678.75,629c-5.37,6.74-8,10.12-6.71,12.41,3.2,5.45,25.56,3.76,39.23-7,3.37-2.65,9.28-7.3,8-12.78-1.36-5.76-10.16-10.24-17.25-10.33C692.9,611.15,687.19,618.33,678.75,629Z",
    transform: "translate(-519.05 -160.52)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M948.39,324.47c8.06-3.93,17.68-8.61,17.06-14-.89-7.78-22.79-12-18.43-16.74.23-.25.64-1,3.56-1.93,12.49-3.87,52.88-3.88,72.63.7,2.36.55,2.32.81,6.67,2.4,41.49,15.1,60.88,14.52,62,20.21,2.06,10.64-63.3,26.25-87.51,32-2.14.51-3.23.77-4.45,1-46.47,9.92-100.16-2.82-98.19-9.4C903,334.69,925.35,335.7,948.39,324.47Z",
    transform: "translate(-519.05 -160.52)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M884.78,358.85c-11,1.41-14,3.39-17,1.18-2.58-1.95-4.13-6.46-2.73-8.69,3.76-6,29.3,3.87,28.85,6.35C893.82,358.36,891.91,357.94,884.78,358.85Z",
    transform: "translate(-519.05 -160.52)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.89,
    y: 222.29,
    width: 152.87,
    height: 265.31,
    rx: 34.74
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 120.28,
    y: 225.79,
    width: 152.87,
    height: 255.48,
    rx: 34.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 137.85,
    y: 329.22,
    width: 117.73,
    height: 11.37,
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 137.85,
    y: 354.94,
    width: 117.73,
    height: 11.37,
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 137.85,
    y: 380.62,
    width: 117.73,
    height: 11.37,
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 137.85,
    y: 416.24,
    width: 117.73,
    height: 11.37,
    rx: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 207.96,
    cy: 244.01,
    rx: 10.31,
    ry: 9.68
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 202,
    height: 446,
    transform: "translate(0 228.33) scale(0.57 0.57)",
    xlinkHref: "data:image/png;base64,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"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M847.54,312.4l47.13,3.93c9.52.79,17.93-7,17.57-12.92l4.27-51.61c2.08-14.92-4.93-24-14.44-24.79l-47.13-3.92c-9.52-.79-17.93,7-18.79,17.43l-4.27,51.61C831,302.54,838,311.61,847.54,312.4Z",
    transform: "translate(-519.05 -160.52)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 833.27,
    y: 227.47,
    width: 77.76,
    height: 83.19,
    rx: 12.89,
    transform: "translate(1200.09 448.62) rotate(-175.27)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 846.57,
    y: 262.47,
    width: 49.39,
    height: 2.92,
    transform: "translate(1198.74 438.29) rotate(-175.27)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 845.83,
    y: 271.23,
    width: 49.39,
    height: 2.92,
    transform: "translate(1196.55 455.72) rotate(-175.27)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 845.29,
    y: 277.81,
    width: 49.39,
    height: 2.92,
    transform: "translate(1194.93 468.81) rotate(-175.27)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 844.75,
    y: 284.39,
    width: 49.39,
    height: 2.92,
    transform: "translate(1193.3 481.9) rotate(-175.27)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 847.13,
    y: 239.37,
    width: 23.24,
    height: 14.89,
    rx: 2.97,
    transform: "translate(1175.17 403.08) rotate(-175.27)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M893.23,297.74",
    transform: "translate(-519.05 -160.52)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M846.67,293.88",
    transform: "translate(-519.05 -160.52)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 738.26,
    y: 571.9,
    width: 29.76,
    height: 34.23,
    rx: 7.86,
    transform: "translate(987.23 1017.51) rotate(180)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 662.19,
    y: 434.85,
    width: 110.22,
    height: 33.68,
    rx: 12.29,
    transform: "translate(915.55 742.85) rotate(180)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 699.62,
    y: 571.34,
    width: 29.76,
    height: 34.23,
    rx: 7.86,
    transform: "translate(909.94 1016.39) rotate(180)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 663.55,
    y: 571.9,
    width: 29.76,
    height: 34.23,
    rx: 7.86,
    transform: "translate(837.81 1017.51) rotate(180)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 695.62,
    y: 373.32,
    width: 49.57,
    height: 18.98,
    rx: 8.46,
    transform: "translate(-517.81 -162.86) rotate(0.19)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 201.39,
    cy: 215.5,
    r: 12.89
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M712.87,390.12l0-.05a3.26,3.26,0,0,0-.58-4.83c-1.64-1-3.61-2.26-5.81-3.69-5.25-3.43-6.06-4.2-9.91-6.56-1.31-.8-1.09-.63-10.38-5.83-5.83-3.26-7-4-9.87-5.49l-4.73-2.53a3.47,3.47,0,0,0-4.53,1.57l-3.2,5.73a3.16,3.16,0,0,0,1.12,4.44l3.39,1.73c7.16,3.66,8,4.13,10.26,5.23,5.18,2.48,9.38,4.09,10.91,4.66,5.3,2,6.67,2.09,12.59,4.22,2.66.95,5,1.85,6.75,2.6A3.46,3.46,0,0,0,712.87,390.12Z",
    transform: "translate(-519.05 -160.52)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M984.17,306.36l38.65.72c2.13-.05,3.83-1.05,3.8-2.22l-.92-35.36c0-1.17-1.78-2.08-3.91-2l-36.4.91c-2.13.06-3.84,1.05-3.81,2.23l.81,31a6.09,6.09,0,0,0,0,1.33A5.94,5.94,0,0,0,984.17,306.36Z",
    transform: "translate(-519.05 -160.52)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 933.81,
    y: 167.78,
    width: 134.86,
    height: 115.66,
    rx: 20.9,
    transform: "translate(-513.02 -185.8) rotate(1.45)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 936.17,
    y: 169.79,
    width: 130.39,
    height: 101.94,
    rx: 20.9,
    transform: "translate(-513.14 -185.81) rotate(1.45)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 943.48,
    y: 176.37,
    width: 53.96,
    height: 85.19,
    rx: 20.9,
    transform: "translate(-513.2 -185.03) rotate(1.45)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1044.16,213.36l-8.37-.21c-3-.08-5.47-1.69-5.42-3.6l.11-4.07c0-1.92,2.55-3.4,5.59-3.33l8.37.22c3,.07,5.47,1.69,5.41,3.6l-.1,4.07C1049.7,212,1047.2,213.44,1044.16,213.36Z",
    transform: "translate(-519.05 -160.52)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1002.84,
    y: 178.42,
    width: 25.48,
    height: 34.92,
    rx: 9.3,
    transform: "translate(1516.74 205.46) rotate(178.55)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1000.95,
    y: 219.13,
    width: 48.84,
    height: 42.51,
    rx: 17.82,
    transform: "translate(1537.45 294.21) rotate(178.55)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 480.55,
    cy: 117.98,
    r: 2.18
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 978.6,
    y: 303.5,
    width: 52.61,
    height: 3.58,
    transform: "translate(-502.33 -210.93) rotate(2.9)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1030.48,
    y: 178.66,
    width: 19.38,
    height: 19.38,
    rx: 6.25,
    transform: "translate(-513.95 -186.8) rotate(1.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAdm);
export default __webpack_public_path__ + "static/media/LoginAdm.667cc9cc2d23e17c13db34e7394d6ec2.svg";
export { ForwardRef as ReactComponent };